module.exports = __webpack_public_path__ + "img/chat_icon_small_white.2e4dd829.svg";